<div>
	<h1 class="typography--display1">District Detail</h1>
	<h2 class="typography--headline">{{ longName }}</h2>
	<dl class="definitions--inline">
		<dt>District ID</dt>
		<dd>{{ id }}</dd>
	</dl>
</div>